import { render, staticRenderFns } from "./TeacherStyle.vue?vue&type=template&id=4c1830b6&scoped=true&"
import script from "./TeacherStyle.vue?vue&type=script&lang=js&"
export * from "./TeacherStyle.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStyle.vue?vue&type=style&index=0&id=4c1830b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1830b6",
  null
  
)

export default component.exports